import {$, html, raw, setHtml} from './dom.js';

/** Toast and modal. Both are plain DOM over the existing styles. */

let toastTimer: ReturnType<typeof setTimeout> | undefined;

export function notify(message: string, tone: 'info' | 'error' | 'success' = 'info'): void {
  const el = $('#toast');
  if (!el) return;
  clearTimeout(toastTimer);
  el.textContent = message;
  el.className = `toast toast-${tone}`;
  el.hidden = false;
  toastTimer = setTimeout(() => {
    el.hidden = true;
  }, tone === 'error' ? 9000 : 5500);
}

export function modal(title: string, body: string): void {
  const dialog = $<HTMLDialogElement>('#modal');
  if (!dialog) return;
  const titleEl = $('#modal-title');
  if (titleEl) titleEl.textContent = title;
  setHtml($('#modal-body'), body);
  if (!dialog.open) dialog.showModal();
}

export function closeModal(): void {
  $<HTMLDialogElement>('#modal')?.close();
}

export function modalIsOpen(): boolean {
  return $<HTMLDialogElement>('#modal')?.open ?? false;
}

/** A blocking progress panel for a transaction, updated in place as it advances. */
export function txProgress(title: string): {
  update: (stage: string, detail?: string, hash?: string) => void;
  fail: (message: string) => void;
  succeed: (body: string) => void;
} {
  const render = (state: string, detail: string, extra = '') =>
    modal(
      title,
      html`<div class="tx-progress">
        <div class="tx-stage">${detail}</div>
        <div class="tx-bar" data-state="${state}"><i></i></div>
        ${raw(extra)}
      </div>`,
    );
  render('working', 'Preparing…');
  return {
    update(stage, detail, hash) {
      const label =
        detail ??
        ({
          simulating: 'Checking with the contract…',
          approving: 'Waiting for the approval…',
          signing: 'Confirm in your wallet…',
          pending: 'Waiting for the chain…',
          done: 'Done.',
          failed: 'Failed.',
        }[stage] ?? stage);
      render(stage === 'done' ? 'done' : 'working', label, hash ? html`<code class="tx-hash">${hash}</code>` : '');
    },
    fail(message) {
      modal(title, html`<div class="tx-progress failed"><div class="tx-stage">${message}</div>
        <button class="secondary" data-action="close">Close</button></div>`);
    },
    succeed(body) {
      modal(title, body);
    },
  };
}
